export default __webpack_public_path__ + "static/media/Dummy 3.fb2d2c95.jpg";